export const getGeoLocation = () => {
    return new Promise((resolve, reject) => {
        try {
            navigator.geolocation.getCurrentPosition(resolve, reject)
        } catch (error) {
            reject(error)
        }
    })
}

/**
 * 
 * @param {function} resolve Callback when location is successfully returned
 * @param {function} reject Callback for when something went wrong
 */
export const locationPermission = (resolve, reject) => {
    const handleError = (err) => {
        switch(err.code) {
            case err.PERMISSION_DENIED:
                reject({ state: 'denied' })
            break;
            case err.POSITION_UNAVAILABLE:
                reject({ state: 'unavailable' })
            break;
            case err.TIMEOUT:
                reject({ state: 'timeout' })
            break;
            case err.UNKNOWN_ERROR:
                reject({ state: 'unknown' })
            break;
        }
    }
    
    navigator.geolocation.getCurrentPosition(e => resolve(e), handleError);
}

export const generateGooglePlacesUri = (input) => {
    return `https://maps.googleapis.com/maps/api/place/autocomplete/json?input=${ input }&key=AIzaSyDYzvTtx6h1jVcwLwdhWiMkDKUhS-Z_PzM`
}